import { DeleteDialog } from 'modules/dialog';
import React from 'react';
import { Link } from 'react-router';

export default class RowItemDanhMucVanBan extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.tenVanBan}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.coQuanBanHanh.tenCoQuanBanHanh}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.loaiVanBan.tenLoaiVanBan}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.linhVucVanBan.tenLinhVucVanBan}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            <Link to={`/quan-ly-van-ban/danh-sach-van-ban/chinh-sua/${this.props.item.id}`} className="itt-edit">Chỉnh sửa</Link>
            <DeleteDialog
              title={'Xoá danh mục'}
              content={'Bạn chắc chắn muốn xoá danh mục này?'}
              redux={this.props.parent}
              deleteId={this.props.item.id}
            />
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/datatable/RowItemDanhMucVanBan.jsx